import React from 'react'
import SettingTemplate from '../../../reusableComponent/SettingTemplate'

const Template = () => {
  return (
    <div>
       <SettingTemplate title="Email"/>
    </div>
  )
}

export default Template